import { Box, Skeleton, Typography, pn } from '@compass/core';
import { Column } from 'devextreme-react/data-grid';
import { DevExpressReport } from 'components';
import { DashboardCard } from '../components/DashboardCard';
import { useGradeLevelData } from '../contexts';
import { GradeLevelDistributionDto } from 'generated/openApi';
import { GradeLevelFilterControls } from './GradeLevelFilterControls';

export const GradeLevelTableCard = () => {
    const { data, loading, error } = useGradeLevelData();
    return <DashboardCard title="Grade Level"><Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <GradeLevelFilterControls />
        {loading ? <Skeleton variant="rounded" height={400} /> : error ? <Typography color="error" align="center">{error}</Typography> :
        <Box sx={{ flexGrow: 1, minHeight: 0 }}><DevExpressReport dataSource={data} fullPageSize showColumnChooser={false}>
            <Column dataField={pn<GradeLevelDistributionDto>('year')} caption="School Year" cellRender={({ value }) => `${value}-${value + 1}`} />
            <Column dataField={pn<GradeLevelDistributionDto>('gradeLevelName')} caption="Grade Level" />
            <Column dataField={pn<GradeLevelDistributionDto>('studentCount')} caption="Students" />
            <Column dataField={pn<GradeLevelDistributionDto>('percentage')} caption="Percentage" cellRender={({ value }) => `${value}%`} />
        </DevExpressReport></Box>}
    </Box></DashboardCard>;
};
